export enum WidgetSize {
  'SMALL' = 'small',
  'MID' = 'mid',
  'BIG' = 'big'
}

export interface WidgetResourceModel {
  //@ts-ignore
  component: string | ComponentDefinition
  label: string
  dark: boolean
  center: boolean
  glossiness: boolean
  id: number
  size: WidgetSize
}

export type WidgetResourceType = WidgetResourceModel[]